import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import logo from "../assets/logo_basic.png";

// ✅ Stripe public key

export default function PremiumOffer() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // -----------------------------
  // START PAYMENT
  // -----------------------------
const startPayment = async () => {
  setLoading(true);

  const stored = localStorage.getItem("user");
  if (!stored) {
    alert("Please login again.");
    setLoading(false);
    return;
  }

  const user = JSON.parse(stored);

  try {
    const response = await axios.post(
      "http://103.104.48.64:5276/api/payments/create-intent",
      {
        userId: user.id,
        email: user.email,
      }
    );

    // ⭐ NEW WAY — Redirect using backend URL
    window.location.href = response.data.url;

  } catch (err) {
    console.error("Payment error:", err);
    alert("Payment failed. Try again.");
  }

  setLoading(false);
};


  return (
    <div className="min-h-screen bg-[#0F0A24] text-white flex flex-col items-center p-8">
      
      <img src={logo} alt="Logo" className="w-20 mt-6 drop-shadow-xl" />

      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-4xl font-bold text-[#EB6AB5] mt-6"
      >
        Reignite Premium
      </motion.h1>

      <p className="text-gray-300 mt-4 max-w-xl text-center leading-relaxed">
        Unlock your <strong>full career roadmap</strong>, personalised resume 
        optimization, job-match insights, AI-resilient career planning and 
        priority mentorship support.
      </p>

      {/* Feature List */}
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl">
        {[
          "Complete Career Roadmap",
          "Resume Optimization by AI + Experts",
          "Job-Match Insights & Career Fit",
          "AI-Resilient Career Planning",
          "Full Results Download (PDF + Summary)",
          "Email & WhatsApp Priority Support",
          "Access to 1:1 Mentorship Session"
        ].map((item) => (
          <div
            key={item}
            className="bg-[#1c1532] p-6 rounded-xl border border-[#EB6AB5]/30 shadow-lg hover:scale-[1.02] transition"
          >
            <p className="text-[#EB6AB5] text-lg font-semibold">{item}</p>
          </div>
        ))}
      </div>

      {/* Stripe Payment Button */}
      <button
        onClick={startPayment}
        disabled={loading}
        className="mt-12 bg-gradient-to-r from-purple-500 to-pink-500 px-10 py-4 rounded-full 
                   text-white font-bold text-lg shadow-xl hover:scale-110 transition"
      >
        {loading ? "Processing..." : "Pay $19.99 – Go Premium"}
      </button>

      {/* Back Button */}
      <button
        onClick={() => navigate("/dashboard")}
        className="mt-6 bg-gradient-to-r from-[#EB6AB5] to-[#ff83d1] px-10 py-3 
                   rounded-full text-[#0F0A24] font-bold text-lg hover:scale-105 transition shadow-xl"
      >
        Back to Dashboard
      </button>
    </div>
  );
}
